import React from 'react';
import { connect } from 'react-redux';
import Button from '../layout/Button';

import {
    PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
    PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
} from '../../actions/PianoTechCustomerActions';

const mapStateToProps = state => ({
    pianoTechCustomer: state.pianoTechCustomer,
    pianoTechPiano: state.pianoTechPiano,
    pianoTechCompany: state.pianoTechCompany,
    pianoTechAppointment: state.pianoTechAppointment,
    pianoTechnician: state.pianoTechnician,
    user: state.user,
});

class AppointmentRow extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    selectedAppointment = (index, key) => () => {
        console.log(`Selected appointment index: ${index}, key: ${key}`);

        const { timeslots } = this.props.pianoTechCustomer;

        // first remove any selected time slots
        timeslots.forEach(daySlots => {
            daySlots.forEach(slot => {
                slot.selected = false;
            });
        });

        // then select the clicked time slot
        if (timeslots[index][key]) {
            timeslots[index][key].selected = true;
        }

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
            timeslots: timeslots,
        });

        const { currentAppointment } = this.props.pianoTechCustomer;
        console.log(`Current appointment: ${JSON.stringify(currentAppointment)}`);

        const startTime = timeslots[index][key].date + 'T' + timeslots[index][key].starttime + ':00.000Z';

        const minutesRequired = currentAppointment.minutesRequired || 0;

        console.log(`Selected start time: ${startTime}`);
        console.log(`Minutes required: ${minutesRequired}`);

        const endTime = new Date(new Date(startTime).getTime() + minutesRequired * 60000).toISOString();

        console.log(`Calculated end time: ${endTime}`);

        // build displayTimeStart and displayTimeEnd in format yyyy-MM-dd HH:mm
        const displayTimeStart = new Date(startTime).toISOString().slice(0, 16).replace('T', ' ');
        const displayTimeEnd = new Date(endTime).toISOString().slice(0, 16).replace('T', ' ');

        let blockStartTime = startTime;
        let blockEndTime = endTime;
        let displayBlockStartTime = displayTimeStart;
        let displayBlockEndTime = displayTimeEnd;

        const minutesBefore = currentAppointment.minutesBefore || 0;
        const minutesAfter = currentAppointment.minutesAfter || 0;

        if (minutesBefore > 0) {
            blockStartTime = new Date(new Date(blockStartTime).getTime() - minutesBefore * 60000).toISOString();
            displayBlockStartTime = new Date(blockStartTime).toISOString().slice(0, 16).replace('T', ' ');
        }

        if (minutesAfter > 0) {
            blockEndTime = new Date(new Date(blockEndTime).getTime() + minutesAfter * 60000).toISOString();
            displayBlockEndTime = new Date(blockEndTime).toISOString().slice(0, 16).replace('T', ' ');
        }

        const { selectedTechnicianId } = this.props.pianoTechCustomer;

        // update the current appointment with the selected time slot
        if (timeslots[index][key]) {
            this.props.dispatch({
                type: PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
                currentAppointment: {
                    ...currentAppointment,
                    appointmentTimeStart: startTime,
                    appointmentTimeEnd: endTime,
                    displayTimeStart: displayTimeStart,
                    displayTimeEnd: displayTimeEnd,
                    blockStartTime: blockStartTime,
                    blockEndTime: blockEndTime,
                    displayBlockStartTime: displayBlockStartTime,
                    displayBlockEndTime: displayBlockEndTime,
                    techniciansId: selectedTechnicianId,
                },
            });
        }
    }

    render() {

        const { appointmentTime, custstarttime, avail, selected, slotkey, outOfSchedule } = this.props;

        const { hideUnavailableSlots } = this.props.pianoTechCustomer;

        console.log(`Rendering appointment row with slotkey: ${slotkey}, appointmentTime: ${appointmentTime}, avail: ${JSON.stringify(avail)}`);

        let className0 = 'bluebutton2';
        let className1 = 'bluebutton2';
        let className2 = 'bluebutton2';
        let className3 = 'bluebutton2';
        let className4 = 'bluebutton2';
        let className5 = 'bluebutton2';
        let className6 = 'bluebutton2';

        if (selected[0]) className0 = 'bluebutton';
        if (selected[1]) className1 = 'bluebutton';
        if (selected[2]) className2 = 'bluebutton';
        if (selected[3]) className3 = 'bluebutton';
        if (selected[4]) className4 = 'bluebutton';
        if (selected[5]) className5 = 'bluebutton';
        if (selected[6]) className6 = 'bluebutton';

        console.log(`hideUnavailableSlots: ${hideUnavailableSlots}`);

        console.log(`outOfSchedule: ${JSON.stringify(outOfSchedule)}`);

        if (outOfSchedule[0] &&
            outOfSchedule[1] &&
            outOfSchedule[2] &&
            outOfSchedule[3] &&
            outOfSchedule[4] &&
            outOfSchedule[5] &&
            outOfSchedule[6] &&
            !selected[0] &&
            !selected[1] &&
            !selected[2] &&
            !selected[3] &&
            !selected[4] &&
            !selected[5] &&
            !selected[6]) {
            console.log('all of the slots are out of schedule and none selected');
            return null;
        }
        if (hideUnavailableSlots) {

            if (!avail[0] &&
                !avail[1] &&
                !avail[2] &&
                !avail[3] &&
                !avail[4] &&
                !avail[5] &&
                !avail[6]) {
                console.log('none of the slots are available and hideUnavailableSlots is true');
                return null;
            }
        }

        let displayAppointmentTime = appointmentTime;
        if (custstarttime) {
            if (custstarttime !== displayAppointmentTime)
                displayAppointmentTime += ' (' + custstarttime + ')';
        }

        return (
            <tr width="100%">
                <td width="12.5%">{displayAppointmentTime}</td>
                <td width="12.5%">
                    <Button className={className0} description={displayAppointmentTime} onClick={this.selectedAppointment(0, slotkey)} disabled={!avail[0]} />
                </td>
                <td width="12.5%">
                    <Button className={className1} description={displayAppointmentTime} onClick={this.selectedAppointment(1, slotkey)} disabled={!avail[1]} />
                </td>
                <td width="12.5%">
                    <Button className={className2} description={displayAppointmentTime} onClick={this.selectedAppointment(2, slotkey)} disabled={!avail[2]} />
                </td>
                <td width="12.5%">
                    <Button className={className3} description={displayAppointmentTime} onClick={this.selectedAppointment(3, slotkey)} disabled={!avail[3]} />
                </td>
                <td width="12.5%">
                    <Button className={className4} description={displayAppointmentTime} onClick={this.selectedAppointment(4, slotkey)} disabled={!avail[4]} />
                </td>
                <td width="12.5%">
                    <Button className={className5} description={displayAppointmentTime} onClick={this.selectedAppointment(5, slotkey)} disabled={!avail[5]} />
                </td>
                <td width="12.5%">
                    <Button className={className6} description={displayAppointmentTime} onClick={this.selectedAppointment(6, slotkey)} disabled={!avail[6]} />
                </td>
            </tr>
        );
    }

}

export default connect(mapStateToProps)(AppointmentRow);

